import api from '../api/axios';
import { offlineEnabled, graceValidToday } from './offlineCache';
import { isOffline as netIsOffline } from './netStatus';
import { rememberSyncToken } from './offlineQueue';

// ── Offline giriş paketi ──────────────────────────────────────────────────────
// Online ikən (hər girişdə + hər 10 dəqiqədən bir) BÜTÜN işçilərin PIN/şifrə bcrypt hash-ləri və
// ONLINE girişlə EYNİ icazələri (silmə qadağası, yalnız baxış, sadə kassir...) bu cihaza yazılır.
// İnternet gedəndə istənilən işçi öz PIN-i/şifrəsi ilə girə bilir (yalnız son girən yox).
// Açıq PIN/şifrə saxlanmır — yalnız bcrypt hash. Paket yalnız işçi sessiyası ilə alınır (QR linki ilə yox).
// Eyni sorğuda gündəlik lisenziya güzəşti də yenilənir → cihaz açıq qalsa belə «bu gün» etibarlı olur.

const AUTH_KEY = 'pos_offline_auth';
const GRACE_KEY = 'pos_license_grace';
const SYNC_EVERY = 10 * 60 * 1000;

const realToken = () => {
    try {
        const t = localStorage.getItem('pos_token') || '';
        return t && t !== 'offline' ? t : '';
    } catch { return ''; }
};

// Offline-da lazım olan oxu məlumatını indi keşə yaz (axios interceptor offline flag açıq olanda yazır).
// Səbəb: girişdən dərhal sonra Masalar yüklənəndə güzəşt (offline flag) hələ gəlməmiş ola bilər →
// /tables keşlənmirdi → offline-da «Masalar yüklənmədi». Paket alınan kimi təkrar çəkirik.
const prefetchOfflineData = () => {
    ['/tables', '/rooms', '/printers', '/printers/pc-ip', '/auth/waiters', '/menu/full?favorites=1'].forEach((u) => {
        api.get(u, { timeout: 20000 }).catch(() => {});
    });
    // Açıq sifarişlərin detalı (offline masa açanda cari vəziyyət görünsün)
    api.get('/tables', { timeout: 20000 }).then((r) => {
        const rows = (r.data && (r.data.data || r.data.tables)) || [];
        const ids = new Set();
        (Array.isArray(rows) ? rows : []).forEach((t) => { if (t.order_id) ids.add(t.order_id); });
        ids.forEach((id) => { api.get(`/orders/${id}`, { timeout: 20000 }).catch(() => {}); });
    }).catch(() => {});
};

let syncing = null;
export const syncOfflineAuth = async () => {
    if (syncing) return syncing;
    if (!realToken() || netIsOffline()) return null;
    rememberSyncToken(); // offline restartdan sonra da sinxron girişsiz getsin
    syncing = (async () => {
        try {
            // 1) Gündəlik lisenziya güzəşti (offline icazə «bu gün» üçün)
            const g = await api.get('/auth/license-grace', { timeout: 15000 });
            if (g.data && g.data.ok && g.data.token) {
                localStorage.setItem(GRACE_KEY, JSON.stringify({
                    token: g.data.token, date: g.data.date, offline: !!g.data.offline_mode_enabled,
                    settings: g.data.settings || null,
                }));
            }
            if (!(g.data && g.data.offline_mode_enabled)) {
                localStorage.removeItem(AUTH_KEY); // offline söndürülüb → paketi saxlama
                return null;
            }
            // 2) Bütün işçilərin giriş paketi
            const r = await api.get('/auth/offline-auth', { timeout: 15000 });
            if (r.data && r.data.ok && r.data.offline_mode_enabled) {
                localStorage.setItem(AUTH_KEY, JSON.stringify(r.data));
                prefetchOfflineData();
                return r.data;
            }
            if (r.data && r.data.ok && !r.data.offline_mode_enabled) localStorage.removeItem(AUTH_KEY);
            return null;
        } catch {
            return null; // şəbəkə xətası — mövcud paket qalır
        } finally {
            syncing = null;
        }
    })();
    return syncing;
};

// waiterToken verilibsə yalnız həmin tenantın paketi qaytarılır (başqa restoranın linki ilə qarışmasın)
export const getOfflineAuth = (waiterToken = '') => {
    try {
        const d = JSON.parse(localStorage.getItem(AUTH_KEY) || 'null');
        if (!d) return null;
        if (waiterToken && d.waiter_token && d.waiter_token !== waiterToken) return null;
        return d;
    } catch { return null; }
};

export const clearOfflineAuth = () => { try { localStorage.removeItem(AUTH_KEY); } catch { /* ignore */ } };

// Offline girişə hazırlıq vəziyyəti → aydın mesaj (səhvən «PIN yanlışdır» yazılmasın)
//   null = offline giriş bu tenantda yoxdur (adi xəta göstərilsin)
export const offlineLoginBlocker = (waiterToken = '') => {
    if (!offlineEnabled()) return null;
    if (!getOfflineAuth(waiterToken)) return 'Offline giriş üçün bu cihazda əvvəlcə internetlə bir dəfə daxil olun.';
    if (!graceValidToday()) return 'Bu gün internetlə yoxlama olmayıb. Offline giriş üçün internetə qoşulub bir dəfə daxil olun.';
    return '';
};

// Tətbiq boyu: 10 dəqiqədən bir + internet qayıdanda + pəncərə önə gələndə yenilə
let started = false;
export const startOfflineAuthSync = () => {
    if (started) return;
    started = true;
    const run = () => { syncOfflineAuth(); };
    setTimeout(run, 3000);
    setInterval(run, SYNC_EVERY);
    window.addEventListener('online', run);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') run(); });
};
